const getFileName = (path) => {
    if (path) {
        const pathStr = typeof path === 'object' && path.path ? path.path : path;
        const lastIndex = String(pathStr).split("/").pop();
        return lastIndex || pathStr;
    }
};

const getFileNameFromAttempt = (path) => {
    if (path) {
        const lastIndex = String(path).split("/").pop();
        return lastIndex || path;
    }
};

/** نام نمایشی فایل از path یا original_name */
const getDisplayFileName = (fileOrPath) => {
    if (!fileOrPath) return null;
    if (typeof fileOrPath === 'object' && fileOrPath.original_name) {
        return fileOrPath.original_name;
    }
    if (typeof fileOrPath === 'object' && fileOrPath.path) {
        return getFileNameFromAttempt(fileOrPath.path);
    }
    return getFileNameFromAttempt(fileOrPath);
};

/** آرایه فایل‌های پاسخ - برای سازگاری با گذشته اگر فقط file_url باشد */
const getAnswerFiles = (answer) => {
    if (!answer) return [];
    if (answer.files && answer.files.length > 0) return answer.files;
    if (answer.file_url) {
        return [{ path: answer.file_url, original_name: getFileNameFromAttempt(answer.file_url) }];
    }
    return [];
};

/** آیا پاسخ محتوا دارد (متن یا فایل) */
const hasAnswerContent = (answer) => {
    if (!answer) return false;
    if (answer.answer && String(answer.answer).trim()) return true;
    return getAnswerFiles(answer).length > 0;
};

/** پس از storeFileURL، فایل‌های تازه را به attempt.answers همان سوال اضافه می‌کند */
const mergeAnswerFilesIntoAttempt = (attempt, questionId, newFiles) => {
    if (!attempt?.answers?.length || !Array.isArray(newFiles) || newFiles.length === 0) {
        return attempt;
    }
    const answers = attempt.answers.map((ans) => {
        if (ans.question_id !== questionId) return ans;
        const prevFiles = Array.isArray(ans.files) ? ans.files : [];
        const merged = [...prevFiles];
        newFiles.forEach((file) => {
            if (!file?.path && !file?.id) return;
            const exists = merged.some(
                (f) => (file.id && f.id === file.id) || (file.path && f.path === file.path)
            );
            if (!exists) merged.push(file);
        });
        return {
            ...ans,
            files: merged,
            file_url: merged[0]?.path ?? ans.file_url ?? null,
        };
    });

    const filledCount = answers.filter((ans) => hasAnswerContent(ans)).length;
    const totalQuestions = (Number(attempt.answered_questions) || 0) + (Number(attempt.unanswered_questions) || 0);
    const questionCount = totalQuestions > 0 ? totalQuestions : answers.length;

    return {
        ...attempt,
        answers,
        answered_questions: filledCount,
        unanswered_questions: Math.max(0, questionCount - filledCount),
    };
};

/** نام نمایشی برای پاسخ (چند فایل یا یک فایل) */
const getAnswerFilesDisplay = (answer) => {
    if (!answer) return null;
    if (answer.files && answer.files.length > 0) {
        const names = answer.files.map(f => f.original_name || getFileNameFromAttempt(f.path));
        return answer.files.length > 1 ? `${answer.files.length} فایل آپلود شد` : names[0];
    }
    if (answer.file_url) {
        return getFileNameFromAttempt(answer.file_url);
    }
    return null;
};

const checkMatchQuestion = (dataQue, dataAtt) => {
    let matches = [];
    // console.log(dataQue ,dataAtt);
    for (var i = 0; i < dataQue.questions.length; i++) {
        for (var j = 0; j < dataAtt.answers.length; j++) {
            if (dataQue.questions[i].id === dataAtt.answers[j].question_id) {
                matches.push({
                    id: dataQue.questions[i].id,
                    option_number: dataAtt.answers[j].option_id,
                })
                // console.log(dataQue.questions[i].id);
                // console.log(dataAtt.answers[j].question_id);
                // matches.push(dataQue.questions[i].id);
            }
        }
    }
    return matches;
}

const checkMatchQuestionURL = (dataQue, dataAtt) => {
    let matches = [];
    for (var i = 0; i < dataQue.questions.length; i++) {
        for (var j = 0; j < dataAtt.answers.length; j++) {
            if (dataQue.questions[i].id === dataAtt.answers[j].question_id) {
                matches.push({
                    id: dataQue.questions[i].id,
                    file_url: dataAtt.answers[j].file_url,
                    files: dataAtt.answers[j].files,
                    answer: dataAtt.answers[j].answer
                })
            }
        }
    }
    return matches;
}

const checkMatchQuestionMixed = (dataQue, dataAtt) => {
    let matches = [];
    if (!dataQue?.questions || !dataAtt?.answers) return matches;
    for (var i = 0; i < dataQue.questions.length; i++) {
        for (var j = 0; j < dataAtt.answers.length; j++) {
            if (dataQue.questions[i].id === dataAtt.answers[j].question_id) {
                matches.push({
                    id: dataQue.questions[i].id,
                    option_id: dataAtt.answers[j].option_id,
                    file_url: dataAtt.answers[j].file_url,
                    files: dataAtt.answers[j].files,
                    answer: dataAtt.answers[j].answer
                })
            }
        }
    }
    return matches;
}

/** مپ کردن پاسخ‌های تستی: question_id -> option_id انتخاب‌شده */
const checkMatchQuestionForTest = (dataQue, dataAtt) => {
    const matches = [];
    if (!dataQue?.questions || !dataAtt?.answers) return matches;
    for (let i = 0; i < dataQue.questions.length; i++) {
        for (let j = 0; j < dataAtt.answers.length; j++) {
            if (dataQue.questions[i].id === dataAtt.answers[j].question_id && dataAtt.answers[j].option_id) {
                matches.push({
                    id: dataQue.questions[i].id,
                    option_id: dataAtt.answers[j].option_id
                })
                break
            }
        }
    }
    return matches
}

const isTestQuestion = (question) => {
    if (!question) return false;
    if (question.type === "test") return true;
    if (question.type === "descriptive") return false;
    return Array.isArray(question.options) && question.options.length > 0;
};

const isDescriptiveQuestion = (question) => !isTestQuestion(question);

const stripHtml = (value) => String(value ?? "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

const isHtmlContent = (value) => {
    const raw = String(value ?? "").trim();
    if (!raw.includes("<")) return false;
    return /<(p|div|span|br|ul|ol|li|strong|em|b|i|u|h[1-6]|table|tr|td|th|img|a)\b[^>]*>/i.test(raw);
};

const hasMeaningfulBody = (value) => stripHtml(value).length > 0;

const OPTION_INLINE_MAX_CHARS = 50;

/** گزینه‌های کوتاه بدون رسانه و بدون HTML → نمایش در یک ردیف (فقط دسکتاپ) */
const canShowOptionsInline = (options) => {
    if (!Array.isArray(options) || options.length === 0 || options.length > 6) return false;
    return options.every((opt) => {
        const text = stripHtml(opt?.body);
        return (
            text.length > 0 &&
            text.length <= OPTION_INLINE_MAX_CHARS &&
            !opt?.image &&
            !opt?.voice &&
            !isHtmlContent(opt?.body)
        );
    });
};

/** تشخیص جهت متن: فارسی/ترکیبی → rtl، فقط انگلیسی → ltr */
const getQuestionTextDirection = (text) => {
    const stripped = stripHtml(text);
    if (!stripped) return "rtl";
    const hasPersianOrArabic = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/.test(stripped);
    if (hasPersianOrArabic) return "rtl";
    const hasLatin = /[A-Za-z]/.test(stripped);
    return hasLatin ? "ltr" : "rtl";
};

const getMixedQuestionCounts = (questions) => {
    if (!Array.isArray(questions)) return { test: 0, descriptive: 0 };
    return questions.reduce((acc, question) => {
        const item = typeof question === "object" ? question : null;
        if (!item) return acc;
        if (isTestQuestion(item)) acc.test += 1;
        else acc.descriptive += 1;
        return acc;
    }, { test: 0, descriptive: 0 });
};

const getQuizTypeLabel = (type) => {
    if (type === "test") return "تستی";
    if (type === "mixed") return "تلفیقی";
    return "تشریحی";
};

/** شماره سوال در پاسخ‌برگ با نقطه (مثلاً ۳.) */
const formatAnswerSheetQuestionNo = (quNo) => {
    if (quNo === null || quNo === undefined || quNo === "") return "";
    return `${quNo}.`;
};

/** نمایش بارم/نمره: در آزمون تلفیقی برای همه سوالات؛ در تست خالص فقط وقتی نوع آزمون rank نباشد */
const shouldShowQuestionScore = (quizType, testType) => {
    if (quizType === "mixed") return true;
    return testType !== "rank";
};

/** جلوگیری از خطای JSON.parse وقتی کلید در localStorage نیست یا JSON نامعتبر است */
const safeParseLocalStorageJson = (key) => {
    try {
        const raw = localStorage.getItem(key);
        if (raw == null || raw === '') return null;
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

const getSessionToken = (session) => session?.quizToken ?? session?.userToken ?? null;

const isGuestSession = (session) => !!(session && (session.role === "guest" || session.phone));

const isExpiredSession = (session) => {
    if (!session?.expireDate) return false;
    const expire = new Date(session.expireDate);
    return !Number.isNaN(expire.getTime()) && expire < new Date();
};

const clearStoredUserSession = () => {
    localStorage.removeItem("userToken");
};

/**
 * نشست معتبر آزمون را برمی‌گرداند. برای مهمان‌ها، quizCode باید با آزمون فعلی یکی باشد
 * تا توکن مهمان آزمون قبلی روی آزمون جدید استفاده نشود.
 */
const getStoredUserSession = (options = {}) => {
    const { quizCode = null, clearInvalid = true } = options;
    const session = safeParseLocalStorageJson("userToken");
    if (!session || !getSessionToken(session) || isExpiredSession(session)) {
        if (clearInvalid) clearStoredUserSession();
        return null;
    }
    if (quizCode && isGuestSession(session) && session.quizCode !== quizCode) {
        if (clearInvalid) clearStoredUserSession();
        return null;
    }
    return session;
};

/** رشتهٔ تاریخ-ساعت نمایش کارنامه (شمسی)؛ اگر خالی باشد null برمی‌گرداند تا UI خطا ندهد */
const formatQuizShowResultDateTime = (value) => {
    if (value == null) return null;
    const s = String(value).trim();
    if (!s) return null;
    return s.replace(' ', ' در ساعت ');
};

const hasPositiveDuration = (d) => {
    if (d == null || d === '') return false;
    const n = Number(d);
    return !Number.isNaN(n) && n > 0;
};

const hasTimeString = (t) => {
    if (t == null) return false;
    return String(t).trim().length > 0;
};

/** متن «پایان آزمون» برای صفحه اطلاعات: اگر هم duration و هم end_time باشد، ساعت پایان (end_time) معتبر است */
const formatQuizEndDescription = (quiz) => {
    if (!quiz) return 'نامحدود';
    if (hasTimeString(quiz.end_time)) {
        return `تا ساعت ${String(quiz.end_time).trim()} (پایان آزمون)`;
    }
    if (hasPositiveDuration(quiz.duration)) {
        return `${quiz.duration} دقیقه بعد از شروع آزمون`;
    }
    return 'نامحدود';
};

export {
    getFileName,
    getFileNameFromAttempt,
    getDisplayFileName,
    getAnswerFiles,
    mergeAnswerFilesIntoAttempt,
    hasAnswerContent,
    getAnswerFilesDisplay,
    checkMatchQuestion,
    checkMatchQuestionURL,
    checkMatchQuestionMixed,
    checkMatchQuestionForTest,
    isTestQuestion,
    isDescriptiveQuestion,
    stripHtml,
    isHtmlContent,
    hasMeaningfulBody,
    canShowOptionsInline,
    getQuestionTextDirection,
    getMixedQuestionCounts,
    getQuizTypeLabel,
    formatAnswerSheetQuestionNo,
    shouldShowQuestionScore,
    safeParseLocalStorageJson,
    getSessionToken,
    isGuestSession,
    isExpiredSession,
    clearStoredUserSession,
    getStoredUserSession,
    formatQuizShowResultDateTime,
    formatQuizEndDescription,
};